<template>
    <div class="page">
        <div class="static-header">
            <jump-transition>
                <div class="back-button touch-reactive" @click="$router.push('/')">
                    <svg class="back-icon" viewBox="0 0 512 512" width="32" height="32"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M244 400L100 256l144-144M120 256h292"/></svg>
                </div>
            </jump-transition>
        </div>

        <div class="header">
            <h2>JP Spelregels</h2>
            <p>Leuk dat je JP wilt spelen. Moet je het spel nog leren of wil je je kennis opfrissen? Dan ben je op de juiste plek. Hier staan alle regels van het spel in verwerkt.</p>
        </div>

        <div class="rules">
            <div class="rule">
                <h3>Wat is JP?</h3>
                <p>
                    JP is een kaartspel voor <strong>twee of meer spelers</strong>. Het doel van het spel is simpel: <br>
                    <span class="tag"><strong>kom niet boven de 100 punten uit!</strong></span><br>
                    Het spel bestaat uit meerdere rondes waarin spelers proberen met zo <strong>laag mogelijke punten</strong> te eindigen.
                </p>
            </div>

            <div class="rule">
                <h3>Kaarten en kaartwaardes</h3>
                <p>
                    JP wordt gespeeld met een standaard kaartspel, <strong>inclusief jokers</strong>.
                    Hier kan je de waarden van de kaarten zien 👇🏼<br><br>
                    - Een aas telt als 1 punt<br>
                    - Een boer, vrouw en koning zijn elk 10 punten waard<br>
                    - Jokers en uitleg kaarten zijn 0 punten waard<br>
                    <strong>De rest</strong> van de kaarten hebben hun <strong>eigen getal</strong> als waarde
                </p>
            </div>

            <div class="rule">
                <h3>Het doel van een ronde</h3>
                <p>
                    Probeer JP te krijgen door in een ronde uit te komen op <strong>5 of minder punten</strong>.
                    Is dit gelukt? Hou het dan nog even voor je 🤫 Pas wanneer je <strong>opnieuw aan de beurt</strong> bent
                    roept je “JP”. Dan <strong>eindigt de ronde direct</strong> en legt iedereen zijn kaarten open.
                </p>
            </div>

            <div class="rule">
                <h3>Start van het spel: delen</h3>
                <p>
                    Voor de ronde begint worden de kaarten <strong>geschud en gedeeld</strong> door de speler die de laatste ronden heeft gewonnen<br>
                    <br>
                    Begint het spel net? Dan kan een speler gekozen worden door het rad<br>
                    <br>
                    De <strong>deler begint bij de speler aan de linkerhand</strong>. Er wordt 3 keer met de klok mee uitgedeeld:<br>
                    - Eerst <strong>2</strong> kaarten<br>
                    - Dan <strong>1</strong> kaart<br>
                    - Vervolgens weer <strong>2</strong> kaarten<br>
                    <br>
                    Er is sprake van een <strong>deelfout</strong> wanneer het delen anders verloopt. 
                    De straf voor de deler is één extra kaart.
                    <br><br>
                    <span class="tag">Het is de <strong>verantwoordelijkheid van de andere
                    spelers</strong> om hierop te letten vóórdat het spel begint. Anders komt de deler hier mee weg!</span>
                </p>
            </div>

            <div class="rule">
                <h3>Verloop van een ronde</h3>
                <p>
                    Na het delen worden de overige kaarten <strong>de pot</strong>.
                    Leg vervolgens één kaart open. Dit is de <strong>speelstapel</strong>. De speler links van de
                    deler begint<br> 
                    <span class="tag">Het spel verloopt altijd met de klok mee!</span>
                </p>
            </div>

            <div class="rule">
                <h3>Jouw beurt</h3>
                <p>
                    <span class="tag">altijd eerst wegleggen en dan pakken</span>
                    <br>
                    <br>
                    <strong>Wegleggen</strong><br>
                    Je mag <strong>meerdere kaarten tegelijk weg leggen</strong> wanneer deze kaarten hetzelfde zijn. 
                    De <strong>kleur of soort speelt geen rol</strong> hierbij.<br>
                    <br>
                    Je mag ook een <strong>straat leggen vanaf 3 opeenvolgende kaarten</strong>, dit moet wel van hetzelfde soort.<br>
                    <br>
                    <strong>Pakken</strong><br>
                    Je moet in jouw beurt de <strong>bovenste kaart</strong> pakken van of:<br>
                    - de speelstapel<br>
                    - de pot<br>
                    <br>
                    <strong>Pak je dezelfde kaart op van de stapel</strong>? Dan mag deze ook op de pot! Dit wordt ook geteld als een dubbele
                </p>
            </div>

            <div class="rule">
                <h3>Het einde van een ronde</h3>
                <p>
                    Zodra iemand JP heeft en zijn beurt heeft afgewacht, mogen alle kaarten op tafel. Om de score te berekenen ga je iedereen met de klok mee af vanaf de persoon die JP heeft.<br>
                    <br>
                    Heeft de volgende speler lagere kaarten? Dan kan deze speler de winnaar van de ronde worden.<br>
                    <br>
                    Heeft de volgende speler dezelfde score? Dan kan de winnaar mogelijk gepaald worden (+30 punten), mits er geen lagere score valt.<br>
                    <br>
                    Zijn jouw kaarten 0 punten waard? Dan heb je de JP 0. Dan worden er tot 25 punten van je totaalscore afgetrokken!<br>
                    <br>
                    Je hoeft de eindstand niet op de eindberekening in te vullen, dit wordt al voor je gedaan.
                </p>
            </div>

            <div class="rule">
                <h3>Checkpoints en scores</h3>
                <p>
                    JP werkt met vaste scoremomenten, zogenaamde checkpoints. Zodra een speler exact op 50 punten
                    uitkomt, wordt zijn score teruggezet naar 0. Komt een speler uit op 69, 75 of 100 punten, dan
                    wordt zijn score teruggezet naar 50. Deze checkpoints kunnen het spel plotseling volledig doen
                    kantelen en maken timing extra belangrijk.
                    <br><br>
                    Een speler die met zijn score boven de 100 uitkomt, verliest het spel onmiddellijk.
                </p>
            </div>

            <div class="rule">
                <h3>JP als drankspel</h3>
                <p>
                    JP kan ook als drankspel worden gespeeld. Spelers nemen een shotje wanneer zij voorbij 25, 50,
                    75 of 100 punten gaan, wanneer zij door een checkpoint teruggezet worden in score, of wanneer
                    zij het spel verliezen. Het is mogelijk dat een speler in één ronde meerdere shotjes moet
                    nemen, afhankelijk van hoe slecht (of spectaculair) hij speelt. 🍻
                </p>
            </div>

            <div class="rule">
                <h3>Einde van het spel</h3>
                <p>
                    Het spel eindigt wanneer één van de spelers de grens van 100 punten overschrijdt. Deze speler
                    verliest het spel. Alle overige spelers mogen zichzelf winnaar noemen, al zal daar
                    waarschijnlijk nog over worden gediscussieerd.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'rules',
    data() {
        return {
        }
    }
}
</script>

<style lang="scss" scoped>

.page {
    padding: 40px;
    overflow-y: auto;
    color: white;

    .back-button {
        margin-left: -12px;
        margin-top: -12px;
    }

    .header {
        margin-bottom: 40px;

        h2 {
            margin-bottom: 8px;
        }
    }

    .rules {
        display: flex;
        flex-direction: column;
        gap: 40px;

        .rule {
            h3 {
                margin-bottom: 8px;
            }
            p {
                line-height: 22px;

                .tag {
                    display: inline-block;
                    padding: 4px 8px;
                    margin: 4px 0;
                    border-radius: 4px;
                    background: #4B9E09;
                }

                span {
                }
            }
        }
    }
}

</style>